import React from 'react';
import { Container, List} from 'semantic-ui-react';
import PaycellLogo from './icons/Paycell';
import PaycellBlackWhite from './icons/PaycellLogoBaW';
import { Link } from 'react-router-dom'

import styles from './footer.module.css'

function Footer() {
    return (
                <Container textAlign='center'>
                    <List horizontal inverted divided link size='small'>
                        <List.Item as='a' href='https://paycell.com.tr/hakkimizda/'>Hakkımızda</List.Item>
                        <List.Item as='a' href='https://paycell.com.tr/gizlilik-ve-guvenlik/'>Gizlilik ve Güvenlik</List.Item>
                        <List.Item as='a' href='https://paycell.com.tr/kullanim-sartlari-ve-sozlesmesi/'>Kullanım Şartları ve Sözleşmesi</List.Item>
                        <List.Item as='a' href='https://paycell.com.tr/kampanyalar/'>Kampanyalar</List.Item>
                        <List.Item as='a' href='https://paycell.com.tr/bize-ulasin/'>Bize Ulaşın</List.Item>
                        <List.Item as={Link} to='/faq'>Sıkça Sorulan Sorular</List.Item>
                        <List.Item as='a' href='https://paycell.com.tr'>
                            <PaycellBlackWhite className={styles.logo} centered='true' />
                        </List.Item>
                    </List>
                </Container>
    );
};

export default Footer;